import { Injectable } from '@angular/core';
import { AuthState, LogoutUser } from '../modules/shared/state/auth';
import { Store } from '@ngxs/store';
import { CanActivate } from '@angular/router';

@Injectable()
export class PlannerGuard implements CanActivate {
  constructor(private store: Store) {}

  public canActivate(): any {
    const isAuthenticated = this.store.selectSnapshot(AuthState.isAuthenticated);
    const isPlanner = this.store.selectSnapshot(AuthState.isPlanner);

    if (!isAuthenticated || !isPlanner) {
      return this.store.dispatch(new LogoutUser());
    }

    return isAuthenticated;
  }
}
